import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import VismaService from "../../services/visma";

const uuidv1 = require('uuid/v1');


export default function Invoicetovisma(props) {
  let inputArea = React.createRef();

  const [activeStep, setActiveStep] = useState(0);
  const [orders, setOrders] = useState(0);
  const [clientID, setClientID] = useState('');
  const [projectID, setProjectID] = useState('');
  const [articles, setArticles] = useState([]);
  const [message, setMessage] = useState('');

  //filter checked orderitems
  useEffect(() => {
    let tmpOrderItems = [];
    props.orderItems.forEach(item => {
      if (item.checked === true) {
        tmpOrderItems.push(item);
      }
    })
    setOrders(tmpOrderItems)
  }
    , []);


  useEffect(() => {
    console.log('Behandel', activeStep, getStepContent(activeStep))

    if (orders.length > 0) {
      //1. ophalen client ID
      if (activeStep === 0) {
        setMessage('');
        VismaService.getCustomers(props.client.clientnumber).then(
          (result) => {
            let id = '';
            try {
              id = result.Data[0].Id;
              setClientID(id)
              setActiveStep(1);
            } catch (ex) {
              setMessage("Ophalen van de klantgegevens met nummer " + props.client.clientnumber + " uit Visma is mislukt. Controleer of er is ingelogd en/of het nummer bestaat.")
            }
          },
          (err) => {
            setMessage("Ophalen van de klantgegevens met nummer " + props.client.clientnumber + " uit Visma is mislukt. Controleer of er is ingelogd en/of het nummer bestaat.")
          }
        )
      }

      //2. ophalen project ID
      if (activeStep === 1) {
        VismaService.getProjects(props.project.projectnumber).then(
          (result) => {
            let id = '';
            try {
              id = result.Data[0].Id;
              setProjectID(id)
              setActiveStep(2);
            } catch (ex) {
              setMessage("Ophalen van de project met nummer " + props.project.projectnumber + " uit Visma is mislukt. Controleer of er is ingelogd en/of het nummer bestaat.")
            }
          },
          (err) => {
            setMessage("Ophalen van de project met nummer " + props.project.projectnumber + " uit Visma is mislukt. Controleer of er is ingelogd en/of het nummer bestaat.")
          }
        )
      }
      //3. ophalen artikelen
      if (activeStep === 2) {
        VismaService.getArticles().then(
          (result) => {
            try {
              setArticles(result.Data)
              setActiveStep(3);
            } catch (ex) {
              setMessage("Ophalen van de artikelen uit Visma is mislukt. Controleer of er is ingelogd.")
            }
          },
          (err) => {
            setMessage("Ophalen van de artikelen uit Visma is mislukt. Controleer of er is ingelogd.")
          }
        )
      }

      //4 versturen naar visma
      if (activeStep === 3) {
       
        VismaService.createInvoice(orders, props.settings, clientID, projectID, articles,props.remarks,props.material,props.materialCost).then((result) => {
          setMessage('Het concept is aangemaakt, log in op Visma Eaccounting om de concept factuur te bekijken.');

        }, (err) => {
          setMessage('Er is een fout opgetreden bij het aanmaken van het concept in Visma: ' + JSON.stringify(err));

        });
        setActiveStep(4);
      }
    }


  }, [activeStep,orders])

  let handleClose = () => {
    props.handleClose();
  }


  function getSteps() {
    return ['Check klant', 'Check project', 'Check artikelen', 'Verzenden naar Visma'];
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return 'Klant worden gecontroleerd...';
      case 1:
        return 'Project worden gecontroleerd...';
      case 2:
        return 'Artikelen worden gecontroleerd...';
      case 3:
        return 'Concept factuur wordt aangemaakt...';
      default:
        return '??';
    }
  }

  return (
    <div>
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Doorsturen naar Visma eAccounting</DialogTitle>
        <DialogContent style={{ minWidth: '400px' }}>

          <Stepper activeStep={activeStep}>
            {getSteps().map((label, index) => {

              return (
                <Step key={label} >
                  <StepLabel>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <br /><br />
          {message}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Sluiten</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
